<template>
  <!-- 主容器 -->
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
      <!-- 用户账号搜索 -->
      <el-form-item label="用户账号" prop="userName">
        <el-input v-model="queryParams.userName" placeholder="请输入用户账号" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 姓名搜索 -->
      <el-form-item label="姓名" prop="nickName">
        <el-input v-model="queryParams.nickName" placeholder="请输入姓名" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 手机号搜索 -->
      <el-form-item label="手机号" prop="phonenumber">
        <el-input v-model="queryParams.phonenumber" placeholder="请输入手机号" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <el-row :gutter="10" class="mb8">
      <!-- 新增按钮 -->
      <!-- <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">
          新增
        </el-button>
      </el-col> -->

      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
      
      <!-- 导入按钮 -->
      <el-col :span="1.5">
        <el-upload class="upload-demo" :action="updateurl+'?updateSupport=' + updateSupport" 
          :auto-upload="false" :on-change="handleFileChange" :show-file-list="false" :headers="headers">
          <el-button type="info" plain icon="el-icon-upload" size="mini">导入</el-button>
        </el-upload>
      </el-col>
      
      <!-- 模板下载按钮 -->
      <el-col :span="1.5">
        <el-dropdown>
          <el-button type="info" plain icon="el-icon-download" size="mini">
            模板<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="downloadTemplate('student')">学生模板</el-dropdown-item>
            <el-dropdown-item @click.native="downloadTemplate('teacher')">教师模板</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange" class="table-container">
      <!-- 选择列 -->
      <el-table-column type="selection" width="55" align="center" />

      <!-- 用户ID列 -->
      <el-table-column label="用户ID" align="center" prop="userId" width="80" />

      <!-- 用户账号列 -->
      <el-table-column label="用户账号" align="center" prop="userName" />

      <!-- 姓名列 -->
      <el-table-column label="姓名" align="center" prop="nickName" />
      
      <!-- 性别列 -->
      <el-table-column label="性别" align="center" prop="sex">
        <template slot-scope="scope">
          {{getSex(scope.row.sex)}}
        </template>
      </el-table-column>

      <!-- 手机号列 -->
      <el-table-column label="手机号" align="center" prop="phonenumber" />

      <!-- 身份列 -->
      <el-table-column label="身份" align="center" prop="remark">
        <template slot-scope="scope">
          {{getRemark(scope.row.remark)}}
        </template>
      </el-table-column>

      <!-- 状态列 -->
      <el-table-column label="状态" align="center" prop="status" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '0' ? 'success' : 'danger'">
            {{ scope.row.status === '0' ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
            修改
          </el-button>

          <!-- 删除按钮 -->
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <!-- 用户账号输入 -->
        <el-form-item label="用户账号" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入用户账号" />
        </el-form-item>
        <!-- 密码输入 -->
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" placeholder="请输入密码" type="password" show-password />
        </el-form-item>
        <!-- 确认密码输入 -->
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="form.confirmPassword" placeholder="请确认密码" type="password" show-password />
        </el-form-item>
        <!-- 姓名输入 -->
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="form.nickName" placeholder="请输入姓名" />
        </el-form-item>
        <!-- 性别选择 -->
        <el-form-item label="性别" prop="sex">
          <el-select v-model="form.sex" placeholder="请选择性别">
            <el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <!-- 手机号输入 -->
        <el-form-item label="手机号" prop="phonenumber">
          <el-input v-model="form.phonenumber" placeholder="请输入手机号" @input="limitPhoneLength" />
        </el-form-item>

        <!-- 身份选择 -->
        <el-form-item label="身份" prop="roles">
          <el-select v-model="form.roleIds" placeholder="请选择身份" multiple>
            <el-option v-for="role in roles" :key="role.roleId" :label="role.roleName" :value="role.roleId" 
              :disabled="role.status == 1"></el-option>
          </el-select>
        </el-form-item>

        <!-- 邮箱输入 -->
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" />
        </el-form-item>

        <!-- 状态选择 -->
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option label="正常" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listUser, getUser, addUser, updateUser, delUser, importDataAll } from '@/api/system/user';
import { listRole } from '@/api/system/role';
import { getToseck } from '@/utils/toseck';
import { download } from "@/utils/request";

export default {
  name: "UserMain",
  data() {
     // 自定义密码验证规则
    const validatePassword = (rule, value, callback) => {
      // 如果是修改操作且密码为空，则跳过验证
      if (this.form.userId && !value) {
        callback();
        return;
      }
      // 如果是新增或密码有值，则进行验证
      if (!this.form.userId && !value) {
        callback(new Error("请输入密码"));
      } else if (value && (value.length < 5 || value.length > 20)) {
        callback(new Error("密码长度必须介于5到20个字符之间"));
      } else if (value && /[<>"'|\\]/.test(value)) {
        callback(new Error("不能包含非法字符：< > \" ' \\ |"));
      } else {
        callback();
      }
    };

    // 自定义确认密码验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      // 如果是修改操作且密码为空，则跳过验证
      if (this.form.userId && !this.form.password) {
        callback();
        return;
      }
      // 只在密码有值时验证确认密码
      if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 导入相关
      updateurl: process.env.VUE_APP_BASE_API + "/system/user/importDataAll",
      headers: {
        'Authorization': 'Bearer ' + getToseck()
      },
      updateSupport: 0,
      
      // 加载状态
      loading: true,
      submitLoading: false, // 提交按钮加载状态
      // 选中行的ID数组
      ids: [],
      // 是否单选（用于判断修改按钮状态）
      single: true,
      // 是否多选（用于判断删除按钮状态）
      multiple: true,
      // 是否显示搜索区域
      showSearch: true,
      // 总条数
      total: 0,
      // 用户列表数据
      userList: [],
      // 角色选项数据
      roles: [],
      // 对话框标题
      title: "",
      // 是否显示对话框
      open: false,

      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: null,
        nickName: null,
        phonenumber: null,
        status: null
      },

      // 表单数据
      form: {
        userId: null,
        userName: null,
        nickName: null,
        phonenumber: null,
        email: null,
        status: "0",
        roleIds: [],
        remark: null,
        password: null,
        confirmPassword: null,
        sex: null
      },
      // 性别选项（修改为文字显示）
      genderOptions: [
        { label: '男', value: '0' },
        { label: '女', value: '1' }
      ],

      // 表单验证规则
      rules: {
        userName: [
          { required: true, message: "用户账号不能为空", trigger: "blur" },
          { min: 1, max: 30, message: "长度在1到30个字符", trigger: "blur" }
        ],
        nickName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          { min: 1, max: 30, message: "长度在1到30个字符", trigger: "blur" }
        ],
        phonenumber: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 11, message: "长度为11位", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        roleIds: [
          { required: true, message: "请选择身份", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择状态", trigger: "change" }
        ],
        password: [
          { validator: validatePassword, trigger: "blur" }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: "blur" }
        ],
      }
    };
  },
  created() {
    this.getList();
    this.getRoleList();
  },
  methods: {
    getRemark(remark) {
      switch(remark) {
        case '学生': return '学生';
        case '教师': return '教师';
        case '管理员': return '管理员';
        default: return '普通角色';
      }
    },
    getSex(sex){
      //alert(sex);
      switch(sex){
        case '0': return '男';
        case '1': return '女';
        default: return '未知';
      }
    },
    
    // 限制手机号输入长度
    limitPhoneLength() {
      if (this.form.phonenumber && this.form.phonenumber.length > 11) {
        this.form.phonenumber = this.form.phonenumber.slice(0, 11);
      }
    },
    
    // 获取用户列表
    getList() {
      this.loading = true;
      listUser(this.queryParams).then(response => {
        this.userList = response.rows;
        console.log(this.userList);
        console.log("鲁彦君");
        this.total = response.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    
    // 获取角色列表
    getRoleList() {
      listRole().then(response => {
        if (Array.isArray(response.rows)) {
          this.roles = response.rows;
        } else {
          this.roles = [];
          this.$message.warning('角色列表格式异常，已加载空列表');
          console.warn('角色列表格式错误:', response);
        }
      }).catch(() => {
        this.roles = [];
        this.$message.error('获取角色列表失败');
      });
    },
    
    // 每页条数变化事件
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    
    // 当前页变化事件
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    
    // 取消操作（关闭对话框）
    cancel() {
      this.open = false;
      this.reset();
    },
    
    // 重置表单
    reset() {
      this.form = {
        userId: null,
        userName: null,
        nickName: null,
        phonenumber: null,
        email: null,
        status: "0",
        roleIds: [],
        remark: null,
        password: null,
        confirmPassword: null,
        sex: null
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    
    // 搜索操作
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    
    // 重置搜索表单
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        userName: null,
        nickName: null,
        phonenumber: null,
        status: null
      };
      this.handleQuery();
    },
    
    // 表格选择项变化事件
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.userId);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    
    // 新增操作
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加用户";
    },
    
    // 修改操作（修复后的版本）
    handleUpdate(row) {
      this.reset();
      const userId = row.userId || this.ids[0];
      getUser(userId).then(response => {
        const userData = response.data;
        
        // 处理性别显示（后端返回0/1，前端显示男/女）
        const sexDisplay = userData.sex === 1 ? '女' : '男';
        
        // 设置表单数据（不显示密码）
        this.form = {
          ...userData,
          sex: sexDisplay,
          password: '',
          confirmPassword: '',
          roleIds: []
        };
        
        // 根据身份设置角色ID
        if (this.form.remark === '学生') {
          this.form.roleIds.push(100); 
        } else if (this.form.remark === '教师') {
          this.form.roleIds.push(101); 
        } else if(this.form.remark === '管理员') {
          this.form.roleIds.push(1); 
        } else {
          this.form.roleIds.push(2); 
        }
        
        this.open = true;
        this.title = "修改用户";
      }).catch(error => {
        this.$message.error('获取用户信息失败');
        console.error('获取用户信息失败:', error);
      });
    },
    
    // 提交表单（修复后的版本）
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          
          // 准备提交数据
          const submitData = {
            ...this.form,
            // // 将性别转换为后端需要的格式（男→0，女→1）
            // sex: this.form.sex === '1' ? '1': '0',
           // 如果密码为空，则移除密码字段
        password: this.form.password ? this.form.password : undefined,
        // 不提交确认密码字段
        confirmPassword: undefined
          };
          
          // 设置身份备注
          const role = this.form.roleIds;
          if (role.includes(100)) {
            submitData.remark = '学生';
          } else if (role.includes(101)) {
            submitData.remark = '教师';
          } else if(role.includes(1)) {
            submitData.remark = '管理员';
          } else {
            submitData.remark = '普通角色';
          }
          
          // 根据是否有ID决定是新增还是修改
          const apiCall = this.form.userId ? updateUser(submitData) : addUser(submitData);
          
          apiCall.then(response => {
            this.$modal.msgSuccess(this.form.userId ? "修改成功" : "新增成功");
            this.open = false;
            this.getList();
            console.log(response);
          }).catch(error => {
            console.error('操作失败:', error);
            this.$message.error(this.form.userId ? "修改失败" : "新增失败");
          }).finally(() => {
            this.submitLoading = false;
          });
        }
      });
    },
    
    // 删除操作
    handleDelete(row) {
      const userIds = row.userId || this.ids;
      this.$confirm(`是否确认删除用户编号为"${userIds}"的用户？`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return delUser(userIds);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    
    // 导出操作
    handleExport() {
      this.$confirm('是否确认导出所有用户数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        download('/system/user/export', {
        ...this.queryParams
      }, `用户表_${new Date().getTime()}.xlsx`);


      }).then(response => {
        this.download(response.msg);
      }).catch(() => {});
    },
    
    // 文件上传处理
    handleFileChange(file) {
      let fileList = file.raw;
      if (!fileList) {
        this.$message.error('请选择文件');
        return;
      }
      const formdata = new FormData();
      formdata.append('file', fileList);
      importDataAll(formdata).then(res => {
        if (res.code === 200) {
          this.$message.success('导入成功');
          this.getList();
        } else {
          this.$message.error('导入失败');
        }
      });
    },
    
    // 下载模板
    downloadTemplate(type) {
      const fileName = type === 'student' ? '学生模板.xlsx' : '教师模板.xlsx';
      const fileUrl = `/templates/${fileName}`;
      
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
  background-color: #d6336c !important;
  color: white !important;
  background-color: #d6336c !important;
  font-weight: bold;
  cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/
::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 操作按钮容器 */
.mb8 {
  margin-bottom: 20px;
}

/* 表格操作按钮 */
.small-padding .el-button {
  margin-left: 0;
  padding: 5px;
}
</style>